module.exports = __webpack_public_path__ + "assets/img/documentSimilarity.80a5712c.png";